import {
  buildCanvasEdgeData,
  CANVAS_EDGE_TYPE,
  resolveApiEdgeType
} from '@/views/flow/helper/exceptionHandling';

/**
 * Keep pasted edge ids consistent with Vue Flow's connection id strategy.
 * @param {{ source: string, sourceHandle?: string, target: string, targetHandle?: string }} params
 */
export function buildVueFlowEdgeId({
  source,
  sourceHandle,
  target,
  targetHandle
}) {
  return `vueflow__edge-${source}${sourceHandle ?? ''}-${target}${targetHandle ?? ''}`;
}

/**
 * Remap one clipboard edge against node/handle maps.
 * @param {object} params
 * @param {object} params.edge
 * @param {Map<string, string>} params.idMap
 * @param {Map<string, string>} params.handleMap
 */
export function remapClipboardEdge({ edge, idMap, handleMap }) {
  const ns = idMap.get(edge.source);
  const nt = idMap.get(edge.target);
  if (!ns || !nt) {
    return { ok: true, skipped: true };
  }

  let remappedSourceHandle;
  if (edge.sourceHandle) {
    remappedSourceHandle = handleMap.get(edge.sourceHandle);
    if (!remappedSourceHandle) {
      return {
        ok: false,
        error: 'source_handle_remap_missing',
        detail: edge.sourceHandle
      };
    }
  }

  let remappedTargetHandle;
  if (edge.targetHandle) {
    remappedTargetHandle = handleMap.get(edge.targetHandle);
    if (!remappedTargetHandle) {
      return {
        ok: false,
        error: 'target_handle_remap_missing',
        detail: edge.targetHandle
      };
    }
  }

  const apiEdgeType = resolveApiEdgeType(edge);
  const nextEdge = {
    ...edge,
    id: buildVueFlowEdgeId({
      source: ns,
      sourceHandle: remappedSourceHandle,
      target: nt,
      targetHandle: remappedTargetHandle
    }),
    source: ns,
    target: nt,
    type: CANVAS_EDGE_TYPE,
    data: buildCanvasEdgeData(apiEdgeType, edge.data || {})
  };

  if (remappedSourceHandle) {
    nextEdge.sourceHandle = remappedSourceHandle;
  }
  if (remappedTargetHandle) {
    nextEdge.targetHandle = remappedTargetHandle;
  }

  return { ok: true, edge: nextEdge };
}
